import { Navigate, useSearchParams } from 'react-router'
import { useQuerySources } from '@hooks/useQuery'
import { useResourcePermissions } from '@hooks/useResourcePermissions'
import EditLayout from './EditLayout'
import ViewLayout from './ViewLayout'

export default function ExistingQueryGate({ id }: { id: string }) {
  const [searchParams] = useSearchParams()
  const mode = searchParams.get('mode') === 'view' ? 'view' : 'edit'

  const { query } = useQuerySources(id)
  const { canEdit } = useResourcePermissions(query.owner.id)

  if (!canEdit && mode !== 'view') {
    return <Navigate to={`/query-builder/${id}?mode=view`} replace />
  }

  if (mode === 'view') {
    return <ViewLayout id={id} />
  }

  return <EditLayout id={id} />
}
